function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
export default function PageRow({
  data,
  blank = false,
  fields
}) {
  numeral.locale('en');
  moment.locale('fr');
  const blank_props = blank === true ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const link = /*#__PURE__*/React.createElement(Link, _extends({
    className: "u-link-only"
  }, blank_props, {
    href: URL('AdminPagesDashboard', front_urls) + '/' + data.id
  }), "Voir la page");
  let output = /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-dashboard__cell Page-title"
  }, data.title, link));
  return output;
}
